// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1UDHz","errorLogs":"EditorFooter_errorLogs__5fOxq"};